import React from 'react';
import ReactDOM from 'react-dom/client';
import { TypeRegisterIndex } from './IRegisterIndex';
import { RegisterIndexPage } from './RegisterIndexPage';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: TypeRegisterIndex[];
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data[0] || {};

root.render(
  <React.StrictMode>
    <RegisterIndexPage {...data} />
  </React.StrictMode>
);
